<!-- eslint-disable max-len -->
<template>
  <div id="form-ui-menu-content">
    <j-menu-info
      v-if="menu === 'information'"
      :ref="menu"
      :ai-detail="aiDetail"
      :form-data="formData"
    />
    <j-menu-model
      v-if="menu === 'model'"
      :ref="menu"
      :ai-detail="aiDetail"
      :form-data="formData"
    />
  </div>
</template>

<script>
/* eslint-disable max-len, no-nested-ternary */
import jMenuInfo from '@/views/ai/menu/jMenuInfo';
import jMenuModel from '@/views/ai/menu/jMenuModel';

export default {
  components: {
    jMenuInfo,
    jMenuModel,
  },
  props: {
    aiDetail: {
      type: Object,
      default: () => {},
    },
    formData: {
      type: Object,
      default: () => {},
    },
    menu: {
      type: String,
      default: 'information',
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
  },
  created() {
  },
  methods: {
    save() {
      switch (this.menu) {
        case 'information':
          this.$refs.information.submitForm();
          break;
        default:
          break;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ai/jAiContent.vue